import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Internal Breeding ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("BREED")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_form_item = _resolveComponent("n-form-item")!
  const _component_n_alert = _resolveComponent("n-alert")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_space = _resolveComponent("n-space")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_form = _resolveComponent("n-form")!

  return (_openBlock(), _createBlock(_component_n_form, {
    model: _ctx.formValue,
    ref: "formRef",
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.breed()), ["prevent"])),
    rules: _ctx.rules
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, {
        segmented: {
        footer: 'soft',
        content: true
      },
        closable: "",
        onClose: _ctx.cancel
      }, {
        header: _withCtx(() => [
          _hoisted_1
        ]),
        footer: _withCtx(() => [
          _createVNode(_component_n_alert, { type: "info" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.platformFee) + " " + _toDisplayString(_ctx.currencyName) + " platform fee and " + _toDisplayString(_ctx.transactionCost) + " " + _toDisplayString(_ctx.transactionCurrencyName) + " transaction costs will be included in the total amount. ", 1)
            ]),
            _: 1
          })
        ]),
        action: _withCtx(() => [
          _createVNode(_component_n_space, { justify: "right" }, {
            default: _withCtx(() => [
              _createVNode(_component_n_button, {
                disabled: _ctx.loading,
                type: "primary",
                "attr-type": "submit",
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_n_form_item, {
            label: "Male Hound",
            path: "maleHoundId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_select, {
                disabled: _ctx.loading,
                class: "big-select",
                options: _ctx.maleHoundOptions,
                value: _ctx.formValue.maleHoundId,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formValue.maleHoundId) = $event)),
                style: {"width":"100%"},
                "render-label": _ctx.renderLabel,
                "render-tag": _ctx.renderTag
              }, null, 8, ["disabled", "options", "value", "render-label", "render-tag"])
            ]),
            _: 1
          }),
          _createVNode(_component_n_form_item, {
            label: "Female Hound",
            path: "femaleHoundId"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_select, {
                disabled: _ctx.loading,
                class: "big-select",
                options: _ctx.femaleHoundOptions,
                value: _ctx.formValue.femaleHoundId,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formValue.femaleHoundId) = $event)),
                style: {"width":"100%"},
                "render-label": _ctx.renderLabel,
                "render-tag": _ctx.renderTag
              }, null, 8, ["disabled", "options", "value", "render-label", "render-tag"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onClose"])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}